import { render, staticRenderFns } from "./viewer.vue?vue&type=template&id=95051c20"
import script from "./viewer.vue?vue&type=script&lang=js"
export * from "./viewer.vue?vue&type=script&lang=js"
import style0 from "./viewer.vue?vue&type=style&index=0&id=95051c20&prod&scopde=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports